import React from 'react';
import { Col, Form } from 'react-bootstrap';

// SelectType Dropdown with inerest_type
const SelectTypeDropdown = ({ c, i, valuesRequired, handleInputChange }) => {
  return (
    <Col lg={6} xs={12} className="mb-3" key={'form-bodyform-' + i}>
      <Form.Group controlId={'validationCustom' + i}>
        <Form.Label>{c.name + ' *'}</Form.Label>
        <Form.Control
          as="select"
          name="selectType"
          onChange={handleInputChange}
          required={c.required}
          defaultValue="-1"
          className="select-contact-form"
          isValid={c.required && valuesRequired.selectType !== undefined}
        >
          <option value="-1" disabled>
            {c.placeholder}
          </option>
          {c.dropdownOptionsType.map((e, index) => (
            <option value={e.interest_type?.option} key={'key_' + index + c.name}>
              {e.interest_type?.option}
            </option>
          ))}
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Seleccione {c.name} por favor
        </Form.Control.Feedback>
      </Form.Group>
    </Col>
  );
};

export default SelectTypeDropdown;
